import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export const ACTIVATION_PENDING_TITLE = 'Venta registrada correctamente';

export const ACTIVATION_PENDING_MESSAGE = 'La venta fue registrada correctamente y estamos terminando de activar el crédito. No es necesario que vuelvas a confirmar esta venta.';

export const ACTIVATION_PENDING_STATUS = 'Activación del crédito en proceso';

const ActivationPendingSuccess = ({ onCloseToSales }) => {
  const handleClose = () => {
    if (typeof onCloseToSales === 'function') {
      onCloseToSales();
      return;
    }

    window.location.href = '/';
  };

  return (
    <div className="rg-sale-success-view rg-sale-success-view--variant-qr">
      <div className="rg-loan-success-qr__confirm">
        <div className="stepper-success-icon">
          <FontAwesomeIcon icon={faCheck} />
        </div>
        <h2 className="rg-sale-step__title rg-sale-step__title--success">
          {ACTIVATION_PENDING_TITLE}
        </h2>
        <p className="rg-loan-success-qr__sub">
          {ACTIVATION_PENDING_MESSAGE}
        </p>
        <p>
          <span className="rg-badge rg-badge--info rg-badge--md">
            {ACTIVATION_PENDING_STATUS}
          </span>
        </p>
      </div>
      <div className="rg-loan-success-qr__close-wrap">
        <button
          type="button"
          className="rg-btn rg-btn--primary rg-btn--lg rg-loan-success-qr__close"
          onClick={handleClose}
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default ActivationPendingSuccess;
